/**
 * Helper function to create a formatted title with Tower prefix
 * @param title The page title (without "Tower - " prefix)
 * @returns The formatted title with prefix
 */
export function formatTowerTitle(title: string): string {
  return `Tower - ${title}`
}

/**
 * Helper function to create a head function with a Tower title
 * @param titleFn Function that returns the page title (without "Tower - " prefix)
 * @returns A head function for TanStack Router
 */
export function withTitle<TParams = Record<string, string>>(
  titleFn: string | ((params: TParams) => string),
) {
  if (typeof titleFn === 'string') {
    return withStaticTitle(titleFn)
  }

  return ({ params }: { params: TParams }) => ({
    meta: [
      {
        title: formatTowerTitle(titleFn(params)),
      },
    ],
  })
}

/**
 * Helper function for static titles (no params)
 * @param title The page title (without "Tower - " prefix)
 * @returns A head function for TanStack Router
 */
export function withStaticTitle(title: string) {
  return () => ({
    meta: [
      {
        title: formatTowerTitle(title),
      },
    ],
  })
}

/**
 * Hook to dynamically update the document title
 * @param title The new title (without "Tower - " prefix)
 */
export function useDynamicTitle(title: string | undefined) {
  if (typeof window !== 'undefined' && title) {
    document.title = formatTowerTitle(title)
  }
}
